import React, { useState } from "react";

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  onConfirm,
  cancelText,
  confirmText,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  cancelText: string;
  confirmText: string;
  children: React.ReactNode;
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white p-6 max-h-full overflow-auto rounded-lg shadow-lg w-auto max-w-6xl">
        {/* Modal Header */}
        <div className="flex justify-between items-center relative">
          <h2 className="text-xl font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 text-3xl absolute right-0 -top-2 hover:text-gray-700"
          >
            &times;
          </button>
        </div>

        {/* Modal Body */}
        <div className="">{children}</div>

        {/* Modal Footer */}
        <div className="flex justify-end gap-4 mt-4">
          {cancelText != "" && (
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
            >
              {cancelText}
            </button>
          )}
          {confirmText != "" && (
            <button
              onClick={onConfirm}
              className="px-4 py-2 bg-primary text-white rounded hover:bg-blue-600"
            >
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
